import { action, noop } from '@reatom/framework'

export const openFavoriteDrawerEvent = action(noop, 'openFavoriteDrawerEvent')
export const closeFavoriteDrawerEvent = action(noop, 'closeFavoriteDrawerEvent')
